jQuery(document).ready(function () {

    /**
     * WebToffee Smart Coupons default behaviour/styles override.
     * Since WT Smart Coupons plugin partialy refreshes itself on every ajax request,
     * this function does the same thing and modifies default product presentation to Swiper slider.
     */
    jQuery(document).ajaxComplete(function () {
        jQuery('.smart-coupons-container').css('display', 'unset');

        if (jQuery('.wt_give_away_products').height() != undefined || jQuery('.wt_give_away_products').height() != null) {
            jQuery('.wt_sc_giveaway_products_cart_page').addClass('swiper');
            jQuery('.wt_give_away_products').addClass('swiper-wrapper');
            jQuery('.wt_get_away_product').addClass('swiper-slide');
            jQuery('.wt_choose_free_product').html('ADD');

            if (jQuery('.smart-coupons-container').find('.swiper-button-next').length == 1
                || jQuery('.smart-coupons-container').find('.swiper-button-next').length == 0)
            {
                jQuery('.swiper').after('<div class="swiper-button-next"></div>');
            }

            if (jQuery('.smart-coupons-container').find('.swiper-button-prev').length == 1
                || jQuery('.smart-coupons-container').find('.swiper-button-prev').length == 0)
            {
                jQuery('.swiper').after('<div class="swiper-button-prev"></div>');
            }

            if (jQuery('.smart-coupons-container').find('.swiper-pagination').length == 1
                || jQuery('.smart-coupons-container').find('.swiper-pagination').length == 0)
            {
                jQuery('.swiper-wrapper').after('<div class="swiper-pagination"></div>');
            }

            const bogoSwiper = new Swiper('.wt_sc_giveaway_products_cart_page', {
                slidesPerView: 2,
                spaceBetween: 35,
                rewind: true,
                allowSlidePrev: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        }
    });

    // ============================================================================
    // !!! Functions below were copied from WebToffee Smart Coupons plugin !!!
    //
    // Because there was some kind of problem with plugins original JS file these
    // were copied and magically it started working.
    // In case something breaks (e.g. Add button stops working), comment out/delete
    // code below or replace it with the one from plugin (in case of plugin update)
    // ============================================================================
    jQuery(document).on('click','.wt_choose_free_product',function(e) {
        e.preventDefault();

        var parent_obj = jQuery(this).closest('.wt_get_away_product');
        if(parent_obj.attr('data-is_purchasable')==1)
        {
            var variation_id=0;
            var variation_id_obj=parent_obj.find('[name="variation_id"]');
            if(variation_id_obj.length>0) /* variable product */
            {
                if(variation_id_obj.val().trim()=="" || variation_id_obj.val().trim()=="0")
                {
                    alert(WTSmartCouponOBJ.labels.choose_variation);
                    return false;
                }else
                {
                    variation_id=variation_id_obj.val();
                }
            }

            var coupon_id = jQuery(this).closest('.wt_give_away_products').attr('coupon');
            if(typeof coupon_id=='undefined')
            {
                return false;
            }

            var product_id = jQuery(this).attr('prod-id');
            if(typeof product_id=='undefined')
            {
                return false;
            }

            var variation_attributes=(parent_obj.find('input[name="wt_variation_options"]').length>0 ? parent_obj.find('input[name="wt_variation_options"]').val() : '');

            var quantity=(parent_obj.find('input[name="wt_giveaway_quantity"]').length>0 ? parent_obj.find('input[name="wt_giveaway_quantity"]').val() : 0);

            var data = {
                'action'        : 'wt_choose_free_product',
                '_wpnonce'      : WTSmartCouponOBJ.nonces.public,
                'product_id'    : product_id,
                'variation_id'  : variation_id,
                'attributes'    : variation_attributes,
                'coupon_id'     : coupon_id,
                'quantity'      : quantity
            };
            wt_sc_ajax_add_giveaway(jQuery(this), data);
        }
    });

    function wt_sc_ajax_add_giveaway(btn_elm, data)
    {
        var html_back=btn_elm.html();
        btn_elm.html(WTSmartCouponOBJ.labels.please_wait);

        var all_btn_elms=jQuery('.wt_add_to_cart_all_btn, .wt_choose_free_product');

        all_btn_elms.prop('disabled', true);
        jQuery('.woocommerce-notices-wrapper').html('');

        jQuery.blockUI();
        jQuery('.blockMsg').hide();

        jQuery.ajax({
            type:"POST",
            async:true,
            url:WTSmartCouponOBJ.ajaxurl,
            data:data,
            success:function(response)
            {
                if(response=='success')
                {
                    location.reload();
                } else {
                    jQuery('.woocommerce-notices-wrapper').html(response);
                    jQuery("html, body").stop(true, true).animate({scrollTop:(jQuery('.woocommerce-notices-wrapper').offset().top-70)}, 500);

                    btn_elm.html(html_back);
                    all_btn_elms.prop('disabled', false);
                }
            },
            error:function()
            {
                btn_elm.html(html_back);
                all_btn_elms.prop('disabled', false);
            }
        });
    }
});